import dynamic from 'next/dynamic';
import Container from './Container';
import CTA from './CTA';
import Buttons from './Buttons';
import Message from './Message';
import Richtext from './Richtext';
import Table from './Table';
import Image from './Image';
import Links from './Links';
import Accordions from './Accordions';
import Video from './Video';
import Tabs from './Tabs';
import Cards from './Cards';
import BonusweltSlider from './BonusweltSlider';
import Columns from './Columns';
import Slider from './Slider';
import Divider from './Divider';
import Quote from './Quote';
import FeatureTiles from './FeatureTiles';
import Timeline from './Timeline';

const streamfields = {
  cta: CTA,
  buttons: Buttons,
  message: Message,
  full_richtext: Richtext,
  simple_richtext: Richtext,
  table: Table,
  code: Richtext,
  container: Container,
  image: Image,
  links: Links,
  accordion: Accordions,
  video: Video,
  tabs: Tabs,
  cards: Cards,
  columns: Columns,
  divider: Divider,
  slider: Slider,
  quote: Quote,
  timeline: Timeline,
  feature_tiles: FeatureTiles,
  bonuswelt_slider: BonusweltSlider,
  map: dynamic(() => import('./Map'), { ssr: false }),
};

export type Streamfields = keyof typeof streamfields;

export default streamfields;
